import service from "@/utils/request";
// 续费提醒列表
export interface renewListData {
  page: number;
  page_size: number;
  student_id?: number;
  course_id?: number;
  course_type?: number;
}
export const renewList = (params: renewListData) => {
  return service({
    url: "/api/v1/student/course/renew_list",
    method: "get",
    params,
  });
};
// 续费提醒设置
interface renewSetData {
  renew_auto_switch: number;
  renew_push_time: string;
  renew_lesson_count: number;
}
export const renewSet = (data: renewSetData) => {
  return service({
    url: "/api/v1/org/config/renew_set",
    method: "post",
    data,
  });
};
// 续费提醒推送
interface renewPushData {
  student_course_account_id?: number;
  student_id?: number;
}
export const renewPush = (data: renewPushData) => {
  return service({
    url: "/api/v1/student/course/renew_push",
    method: "post",
    data,
  });
};

// 续费记录列表
export interface renewRecordListInter {
  page: number;
  page_size: number;
  sort_field?: string;
  sort_type?: string;
  key_word?: string;
  subject_ids?: number[];
  course_ids?: number[];
  course_type?: number;
  log_start_date?: string;
  log_end_date?: string;
  renew_type?: number;
  follow_staff_ids?: number[];
  edu_teacher_ids?: number[];
  teacher_ids?: number[];
  renew_status?: number;
  renew_start_date?: string;
  renew_end_date?: string;
}

export const renewRecordListApi = (data: renewRecordListInter) => {
  return service({
    url: "/api/v1/student/course/renew_record_list",
    method: "post",
    data,
  });
};
// 续费记录列表统计
export const renewRecordCountApi = (data: renewRecordListInter) => {
  return service({
    url: "/api/v1/student/course/renew_record_count",
    method: "post",
    data,
  });
};
// 续费提醒导出
export const renewListExportApi = (params: renewListData) => {
  return service({
    url: "/api/v1/student/course/renew_list/export",
    method: "get",
    params,
  });
};
// 续费提醒配置详情
export const renewConfigDetailApi = () => {
  return service({
    url: "/api/v1/org/config/renew_detail",
    method: "get",
  });
};
